import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full acontent" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("titles.ml_requests"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialogResource()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-plus-circle-outline"),
                  ]),
                  _vm._v(" Solicitar "),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(_vm.$t("botones.boton_filtrar")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "filters-inca d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer pb-0" }, [
                _vm._v(" " + _vm._s(_vm.$t("titles.search_filters")) + " "),
              ]),
              _c(
                VCardText,
                [
                  _c(VRow, { attrs: { dense: "dense" } }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3 text-right" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "default mr-1",
                            attrs: { outlined: "outlined" },
                            on: { click: _vm.onLimpiar },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                        ),
                        _c(
                          VBtn,
                          {
                            staticClass: "primary",
                            on: { click: _vm.onSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.search")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  key: _vm.key_table,
                  staticClass: "table-inca",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.solicitudes,
                    "sort-by": _vm.pagination.sort_by,
                    "sort-desc": _vm.pagination.sort_desc,
                    "hide-default-footer": true,
                    page: _vm.pagination.current,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                    pagination: function ($event) {
                      _vm.pagination.total = $event.itemsLength
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.request_date",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.formatDateLast(item.request_date))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.pipelines",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "ul",
                            { staticClass: "m-0 p-0" },
                            _vm._l(item.pipelines, function (pipe) {
                              return _c("li", [_vm._v(_vm._s(pipe.name))])
                            }),
                            0
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.acciones",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          item.status == "REQUESTED"
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca",
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onViewRequest(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v(" icon-view "),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.applicant == _vm.getUserEmail
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca",
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onEditRequest(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v(" icon-edit "),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.status == "REQUESTED" && _vm.isMLSteward
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca",
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onRejectRequest(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v(" icon-decline "),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.status == "REQUESTED" && _vm.isMLSteward
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca",
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onApproveRequest(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v(" icon-check "),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.status == "APPROVED"
                            ? _c(
                                VBtn,
                                {
                                  staticClass: "btn-icon-inca",
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onCompileRequest(item)
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, [
                                    _vm._v(" mdi-package-variant-closed "),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer pb-0",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("titles.search_filters")) + " "
                        ),
                      ]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "dense" } },
                          [
                            _c(
                              VCol,
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.filtros.name,
                                    placeholder: _vm.filtros.name,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                  },
                                  model: {
                                    value: _vm.filters.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "name", $$v)
                                    },
                                    expression: "filters.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: "Pipelines",
                                    placeholder: "Pipelines",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                  },
                                  model: {
                                    value: _vm.filters.pipeline,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "pipeline", $$v)
                                    },
                                    expression: "filters.pipeline",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: _vm.filtros.type,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                    items: _vm.types,
                                  },
                                  on: { change: _vm.onChangeType },
                                  model: {
                                    value: _vm.filters.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "type", $$v)
                                    },
                                    expression: "filters.type",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: _vm.filtros.status,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto",
                                    items: _vm.estados,
                                  },
                                  on: { change: _vm.onChangeStatus },
                                  model: {
                                    value: _vm.filters.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "status", $$v)
                                    },
                                    expression: "filters.status",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(
                                  VMenu,
                                  {
                                    ref: "menu2",
                                    attrs: {
                                      "close-on-content-click": false,
                                      "return-value": _vm.dates,
                                      transition: "scale-transition",
                                      "offset-y": "",
                                      "max-width": "290px",
                                      "min-width": "290px",
                                    },
                                    on: {
                                      "update:returnValue": function ($event) {
                                        _vm.dates = $event
                                      },
                                      "update:return-value": function ($event) {
                                        _vm.dates = $event
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                VTextField,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        "append-icon": "event",
                                                        readonly: "",
                                                        dense: "",
                                                        outlined: "",
                                                        "hide-details": "auto",
                                                        label: _vm.$t(
                                                          "tabla_solicitudes.created_date"
                                                        ),
                                                      },
                                                      on: {
                                                        "click:append":
                                                          on.click,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dateRangeText,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.dateRangeText =
                                                            $$v
                                                        },
                                                        expression:
                                                          "dateRangeText",
                                                      },
                                                    },
                                                    "v-text-field",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      899232111
                                    ),
                                    model: {
                                      value: _vm.menu2,
                                      callback: function ($$v) {
                                        _vm.menu2 = $$v
                                      },
                                      expression: "menu2",
                                    },
                                  },
                                  [
                                    _c(
                                      VDatePicker,
                                      {
                                        attrs: { range: "", scrollabel: "" },
                                        model: {
                                          value: _vm.filters.fechas,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.filters, "fechas", $$v)
                                          },
                                          expression: "filters.fechas",
                                        },
                                      },
                                      [
                                        _c(VSpacer),
                                        _c(
                                          VBtn,
                                          {
                                            attrs: {
                                              text: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onLimpiarFiltroFecha()
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            attrs: {
                                              text: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.menu2 = false
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.cancel"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            attrs: {
                                              text: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.menu2 = false
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btns.ok")))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "outlined" },
                                    on: { click: _vm.onLimpiar },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary",
                                    on: { click: _vm.onSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("dialogs-component", {
        ref: "DIALOG_RESOURCE",
        attrs: { title: "Crear solicitud", width: 500 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(VSubheader, { staticClass: "font-weight-bold" }, [
                  _vm._v(" Elija qué tipo de recurso solicitar "),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "primary",
                    on: {
                      click: function ($event) {
                        return _vm.goToCreatePipeline()
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [_vm._v("mdi-pipe")]),
                    _vm._v(" Pipeline "),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "primary",
                    on: {
                      click: function ($event) {
                        return _vm.goToCreateBigquery()
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("mdi-database"),
                    ]),
                    _vm._v(" Bigquery "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: "MODAL_CONFIRM_APPROVE",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de APROBAR la solicitud?",
        },
        on: { onConfirm: _vm.onConfirmApprove },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "form--row" },
                  [
                    _c(
                      VCol,
                      [
                        _c(VTextField, {
                          attrs: {
                            dense: "",
                            label: "Respuesta",
                            outlined: "",
                            "hide-details": "auto",
                          },
                          model: {
                            value: _vm.response,
                            callback: function ($$v) {
                              _vm.response = $$v
                            },
                            expression: "response",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: "MODAL_CONFIRM_REJECT",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de RECHAZAR la solicitud?",
        },
        on: { onConfirm: _vm.onConfirmReject },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "form--row" },
                  [
                    _c(
                      VCol,
                      [
                        _c(VTextField, {
                          attrs: {
                            dense: "",
                            label: "Respuesta",
                            outlined: "",
                            "hide-details": "auto",
                          },
                          model: {
                            value: _vm.response,
                            callback: function ($$v) {
                              _vm.response = $$v
                            },
                            expression: "response",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: "MODAL_CONFIRM_COMPILE",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de COMPILAR la solicitud?",
        },
        on: { onConfirm: _vm.onConfirmCompileRequest },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }